'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSync = function MdSync(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 30v-5l6.6 6.6-6.6 6.8v-5c-7.3 0-13.4-6.1-13.4-13.4 0-2.6 0.8-5.1 2.2-7.1l2.4 2.4c-0.8 1.4-1.2 3-1.2 4.7 0 5.5 4.5 10 10 10z m0-23.4c7.3 0 13.4 6.1 13.4 13.4 0 2.6-0.8 5.1-2.1 7.1l-2.5-2.4c0.8-1.4 1.2-3 1.2-4.7 0-5.5-4.5-10-10-10v5l-6.6-6.6 6.6-6.8v5z' })
        )
    );
};

exports.default = MdSync;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/sync.js
// module id = 2033
// module chunks = 168707334958949